import type { ColorScheme } from '../../types'

export type { ColorScheme }

export type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl'

// Named sizes → box dimension. A raw CSS length may be passed instead.
export const SPINNER_SIZES: Record<SpinnerSize, string> = {
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '40px',
}

// Default ring color, per scheme. Any token may be passed to override it.
export const spinnerColor = (colorScheme: ColorScheme): string =>
  colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary'
